"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionFilterHelper = void 0;
var lodash_1 = __importDefault(require("lodash"));
var constants_1 = __importDefault(require("../constants"));
var contentConstants_1 = __importDefault(require("../contentConstants"));
var deriveUniqueResponseOptionGroups = function (questions) {
    var responseOptionGroups = (0, lodash_1.default)(questions)
        .map(function (q) { return q.responseOptionGroup || ''; })
        .filter(function (r) { return r !== ''; })
        .uniq()
        .sort()
        .value();
    return responseOptionGroups.map(function (r) { return ({
        name: constants_1.default.FILTER_PREFIX_ROG + r,
        displayText: r,
        group: contentConstants_1.default.FILTER_RESPONSE_OPTION_GROUPS,
    }); });
};
var deriveUniqueTags = function (questions) {
    var tags = (0, lodash_1.default)(questions)
        .map(function (q) { return q.tagNames || []; })
        .flatten()
        .uniq()
        .sort()
        .value();
    return tags.map(function (t) { return ({
        name: constants_1.default.FILTER_PREFIX_TAG + t,
        displayText: t,
        group: contentConstants_1.default.FILTER_TAGS,
    }); });
};
var deriveUniqueQuestionTemplates = function (questions) {
    var questionTemplates = (0, lodash_1.default)(questions)
        .map(function (q) { return q.templateNames || []; })
        .flatten()
        .uniq()
        .sort()
        .value();
    return questionTemplates.map(function (qt) { return ({
        name: constants_1.default.FILTER_PREFIX_QUESTIONTEMPLATE + qt,
        displayText: qt,
        group: contentConstants_1.default.FILTER_QUESTION_TEMPLATES,
    }); });
};
var deriveUniqueCultures = function (availableCultures, questions) {
    var cultures = lodash_1.default.keyBy(availableCultures, 'name');
    var languages = (0, lodash_1.default)(questions)
        .map(function (q) { return q.languages; })
        .flatten()
        .uniq()
        .value();
    var languageOptions = languages.map(function (l) {
        var culture = cultures[l];
        return {
            name: constants_1.default.FILTER_PREFIX_LANGUAGE + l,
            displayText: culture ? culture.displayText : l,
            group: contentConstants_1.default.FILTER_LANGUAGES,
        };
    });
    return lodash_1.default.orderBy(languageOptions, function (l) { return l.displayText; });
};
var deriveUniqueBenchmarks = function (availableBenchmarks, questions) {
    var allBenchmarks = lodash_1.default.keyBy(availableBenchmarks, 'benchmarkId');
    var benchmarkIds = (0, lodash_1.default)(questions)
        .map(function (q) { return q.benchmarkIds; })
        .flatten()
        .uniq()
        .value();
    var benchmarkOptions = benchmarkIds.map(function (id) {
        var benchmark = allBenchmarks[id];
        return {
            name: constants_1.default.FILTER_PREFIX_BENCHMARK + id,
            displayText: benchmark ? benchmark.displayText : id + '',
            group: contentConstants_1.default.FILTER_BENCHMARKS,
        };
    });
    return lodash_1.default.orderBy(benchmarkOptions, function (l) { return l.displayText; });
};
exports.QuestionFilterHelper = {
    deriveUniqueBenchmarks: deriveUniqueBenchmarks,
    deriveUniqueCultures: deriveUniqueCultures,
    deriveUniqueQuestionTemplates: deriveUniqueQuestionTemplates,
    deriveUniqueResponseOptionGroups: deriveUniqueResponseOptionGroups,
    deriveUniqueTags: deriveUniqueTags,
};
